import { simpleFetch } from "./acCommon"

export const FETCHBOOKING_REQUEST = "FETCHBOOKING_REQUEST"
export const FETCHBOOKING_SUCCESS = "FETCHBOOKING_SUCCESS"
export const FETCHBOOKING_FAILURE = "FETCHBOOKING_FAILURE"

export const SUBMITBOOKINGMESSAGE_REQUEST = "SUBMITBOOKINGMESSAGE_REQUEST"
export const SUBMITBOOKINGMESSAGE_SUCCESS = "SUBMITBOOKINGMESSAGE_SUCCESS"
export const SUBMITBOOKINGMESSAGE_FAILURE = "SUBMITBOOKINGMESSAGE_FAILURE"


export const BOOKINGDETAILS_DATACHANGE = "BOOKINGDETAILS_DATACHANGE"
export const bookingDetailsDataChange = changes => ({ type: BOOKINGDETAILS_DATACHANGE, changes })

export const submitBookingMessage = () => (dispatch, getState) => {
	let { currentMessage, id, dummy, parentBookingID, start } = getState().dataReducer.booking
	if(currentMessage !== '') {
		let init = {
			method: 'POST',
			body: JSON.stringify({ message: { body: currentMessage } })
		}
		let url = ''
		if (dummy) {
			url = `/customers/bookings/${parentBookingID}/messages`
			init.recurrence_date = start.format('YYYY-MM-DD')
		}
		else {
			url = `/customers/bookings/${id}/messages`
		}
		dispatch(simpleFetch(url, init, 'SUBMITBOOKINGMESSAGE'))
	}
}



// WEBPACK FOOTER //
// ./src/actions/acBookingDetails.js